import { css } from '@emotion/core';

import { Sizes } from 'src/design-system/style-types';
import { Theme } from 'src/design-system/theme';
import { zIndex } from 'src/utils/zIndex';

const heights = {
  xs: 4,
  sm: 8,
  md: 28,
  lg: 31,
  xl: 35,
  '2xl': 39,
  '3xl': 45,
  '4xl': 52,
  '5xl': 60,
};

const progressBar =
  ({ size }: { size: Sizes }) =>
  (theme: Theme) =>
    css`
      border-radius: 2px;
      width: auto;
      padding: 0;
      height: ${heights[size]}px;
      background-color: ${theme.colors.grey10};
    `;

const filler =
  ({ percentageComplete }: { percentageComplete: number }) =>
  (theme: Theme) =>
    css`
      width: ${percentageComplete}%;
      min-width: 5%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${theme.colors.accent};
      transition: width 0.2s ease-in;
      position: relative;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-image: linear-gradient(
          -45deg,
          rgba(255, 255, 255, 0.2) 25%,
          transparent 25%,
          transparent 50%,
          rgba(255, 255, 255, 0.2) 50%,
          rgba(255, 255, 255, 0.2) 75%,
          transparent 75%,
          transparent
        );
        z-index: ${zIndex.One};
        background-size: 50px 50px;
        animation: move 2s linear infinite;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        overflow: hidden;
      }
    `;

export const style = { progressBar, filler };
